<template>
  <!-- 厂商成套设备订单列表 -->
  <div class="order">
    <div class="tabbar">
      <el-button
        type="primary"
        size="mini"
        v-for="(item, index) in category"
        :key="index"
        :plain="index != categoryIndex"
        @click="changeTable(index)"
      >
        {{ item.name }}
          ({{item.id==null?buttonSize.csctnull:item.id==7?buttonSize.csct7:item.id==1?buttonSize.csct1:item.id==2?buttonSize.csct2
          :item.id==3?buttonSize.csct3:item.id==24?buttonSize.csct24:item.id==34?buttonSize.csct34:item.id==5?buttonSize.csct5
          :item.id==6?buttonSize.csct6:item.id==8?buttonSize.csct8:0}})
      </el-button>
    </div>

      <div class="btnGroup" style="margin-left: 30px">

          <el-input v-model="queryParams.projectname" placeholder="请输入工程名称" clearable @keyup.enter.native="getOrderList1"
                    style="width: 200px;" />
          <el-button type="primary" plain style="margin-left: 10px;" @click="getOrderList1">查询
          </el-button>

      </div>

    <div class="table">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          align="center"
          :index="count"
        ></el-table-column>
        <el-table-column prop="title" label="订单信息" align="center">
          <template slot-scope="scope">
            <div class="table-order-status">
              <span>{{
                scope.row.vArray == 2
                  ? scope.row.orderNo + "合并订单"
                  : scope.row.orderNo
              }}</span>
              <span v-if="scope.row.status == 60">(续)</span>
            </div>
          </template>
        </el-table-column>
          <el-table-column label="工程名称" align="center" prop="projectname" />
          <el-table-column label="客户信息" align="center" prop="masterName" />
        <el-table-column
          prop="startTime"
          label="开始时间"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column label="租用时长" width="180" align="center">
          <template v-slot="scope">
            <div class="table-order-status">
              {{ scope.row.orderPro!=null?scope.row.orderPro.duration:"" }}/月
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="advance"
          label="订单价格"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column prop="status" label="订单状态" align="center">
          <template v-slot="scope">
<!--              <div>-->
                  {{scope.row.orderSatus == 0 ? '未确认提交': scope.row.orderSatus == 1 ? '待厂商确认' : scope.row.orderSatus == 2 ? '待平台签约'
                  : scope.row.orderSatus == 3 ? '待客户支付租金' : scope.row.orderSatus == 24 ? '待厂商支付服务费'
                      : scope.row.orderSatus == 34 ? '待平台确认服务费': scope.row.orderSatus == 5 ? '待厂商安装验收'
                          : scope.row.orderSatus == 6 ? '待客户用电完成' : scope.row.orderSatus == 7 ? '已完成'
                              : scope.row.orderSatus == 8 ? '已完成(已评价)' : scope.row.orderSatus == 70 ? '中止订单' : '其他'}}
<!--              </div>-->
<!--            <div class="table-order-status">-->
<!--              {{ getStatus(scope.row.orderSatus, scope.row.status, scope.row) }}-->
<!--            </div>-->
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template v-slot="scope">
            <slot :row="scope.row" :column="scope.column">
              <div class="scope-button" style="justify-content: center">
                <div
                  class="scope-button-item scope-button-blue"
                  @click="hanldeCheck(scope.row)"
                >
                  <i class="el-icon-search"></i>
                  查看
                </div>
              </div>
            </slot>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div
      style="
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        padding-bottom: 20px;
      "
      v-if="total > query.pageSize"
    >
      <el-pagination
        background
        layout="prev, pager, next,total"
        :total="total"
        :page-size="query.pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {equOrderList, delOrder, getButtonSizeApi} from "../../http/factory/add-eme.js";
export default {
  name: "order",
  data() {
    return {
        queryParams:{
            projectname:null,
        },
      category: [
        {
          id: null,
          name: "全部状态",
        },
        {
          id: 1,
          name: "待厂商确认",
        },
        {
          id: 2,
          name: "待平台签约",
        },
        {
          id: 3,
          name: "待客户支付租金",
        },
        {
          id: 24,
          name: "待厂商支付服务费",
        },
        {
          id: 34,
          name: "待平台确认服务费",
        },
        {
          id: 5,
          name: "待厂商安装验收",
        },
        {
          id: 6,
          name: "待客户用电完成",
        },
        {
          id: 7,
          name: "已完成",
        },
        {
          id: 8,
          name: "已评价",
        },
      ],
      status: [
        "",
        "平台定制合同中",
        "待确认合同",
        "待平台制定签约合同",
        "待确认收款",
      ],
        buttonSize:[],
      categoryIndex: 0,
      tableData: [],
      query: {
        pageSize: 15,
        pageNum: 1,
        status: null,
      },
      total: 0,
    };
  },
  methods: {
    count(index) {
      return (this.query.pageNum - 1) * this.query.pageSize + index + 1;
    },
    getStatus(status, sta, row) {
      for (let item of this.category) {
        if (status == 50) {
          if (sta == 1) {
            return "终止申请中（待厂商确认）";
          }
          if (sta == 2) {
            return "终止申请中（待平台确认）";
          }
          if (sta == 3) {
            if (row.statuson == 2) {
              return "终止订单（待客户确认协议）";
            } else {
              return "终止订单（待确认协议）";
            }
          }
          if (sta == 4) {
            return "已终止（退款中）";
          }
          if (sta == 5) {
            if (row.statuson == 4) {
              return "已终止";
            } else {
              return "已终止（待确认收款）";
            }
          }
          if (sta == 6) {
            return "已终止";
          }
          return "终止订单";
        }
        if (item.id == status) {
          return item.name;
        }
      }
    },
    changeTable(index) {
      this.categoryIndex = index;
      this.currentPage = 1;
      this.fetchData();
    },
    hanldeCheck(row) {
      this.$router.push({
        path: "/factoryUser/factoryDetailEqu",
        query: {
          id: row.id,
        },
      });
    },
    hanldeRefuse(row) {
      delOrder({
        id: row.id,
      }).then((res) => {
        this.$message({
          message: "取消订单成功！",
          type: "success",
          duration: 2000,
        });
        this.fetchData();
      });
    },
    fetchData() {
      let data = {
        pageSize: this.query.pageSize,
        pageNum: this.query.pageNum,
        orderType: 0,
          projectname:this.queryParams.projectname,
        orderSatus: this.category[this.categoryIndex]["id"],
        superType: -1,
      };
      equOrderList(data).then((res) => {
        this.tableData = res.rows;
          for (var i = 0; i < this.tableData.length; i++) {
              if(this.tableData[i].paymentVoucher===null){
                  this.tableData[i].vArray=0;
              }else{
                  this.tableData[i].vArray=this.tableData[i].paymentVoucher.split(',').length;
              }
          }
        this.total = res.total;
      });
      this.getButtonSize()
    },
      getButtonSize(){
        getButtonSizeApi({
            orderType: 0,
            superType: -1,
            projectname:this.queryParams.projectname,
        }).then(response=>{
            console.log(response)
            this.buttonSize=response;
        })
      },
      getOrderList1(){
          this.query.pageNum=1;
          this.fetchData();
      },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.fetchData();
    },
  },

  mounted: function() {
    //模板编译/挂载之后
    if (this.$route.query.index != undefined) {
      this.changeTable(this.$route.query.index);
    } else {
      this.fetchData();
    }
  },
};
</script>

<style lang="less" scoped="scoped">
.order {
  width: 100%;
  background: @vue-bg-color;

  .tabbar {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    padding: 10px @vue-spacing-row-base;
    box-sizing: border-box;

    .el-button {
      margin-bottom: 10px;
      margin-left: 10px;
    }
  }

  .table {
    width: 100%;
    padding: @vue-spacing-col-base @vue-spacing-row-base;
    box-sizing: border-box;

    .table-equipment {
      display: flex;
      flex-wrap: wrap;

      .equipment-name {
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0px @vue-spacing-row-base*2;
        cursor: pointer;
      }

      .equipment-name:hover {
        background: @vue-bg-color-grey;
      }
    }

    .table-order-status {
      span {
        color: @vue-text-color-red;
      }
    }
  }

  .page-pager {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0px @vue-spacing-row-lg;
    box-sizing: border-box;
  }
}
</style>
